module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-7-small-f96a7e3d89a2efc18da19b3f162f5ca9.jpg";